'use strict';

var _ = require('lodash');
var GeometryUtils = require('../../../utils/Geometry');

module.exports = {

  _eventsUnRegistry: null,

  _newUnregisterEventsRegistry: function () {
    return Object.create({
      _fns: [],
      add: function (fn) {
        if (this._fns.indexOf(fn) === -1) {
          this._fns.push(fn);
        }
      },
      reset: function () {
        this._fns = [];
      },
      run: function () {
        for (var i = this._fns.length - 1; i >= 0; i--) {
          this._fns[i]();
        }
        this._fns = [];
      }
    });
  },

  /**
   * @param  {String} eventname
   * @param  {Function} handler
   * @param  {Object} target A LeafletLayer or DOM element
   * @return {Function} A remove method
   */
  on: function (eventname, handler, context, target) {
    target = target || this._draw._map;
    // make sure this event is only registered once
    target.removeEventListener(eventname, handler);
    target.addEventListener(eventname, handler, context);

    var removeEventListener = function () {
      target.removeEventListener(eventname, handler, this);
    }.bind(context);

    this._eventsUnRegistry = this._eventsUnRegistry || this._newUnregisterEventsRegistry();
    this._eventsUnRegistry.add(removeEventListener);

    return removeEventListener;
  },

  once: function (eventname, handler, context, target) {
    target = target || this._draw._map;
    target.once(eventname, handler, context);
  },

  /**
   * Removes all registered layer event listeners.
   */
  _removeEventListeners: function () {
    if (this._eventsUnRegistry) {
      this._eventsUnRegistry.run();
    }
  },

  /**
   * Registers all shared event listeners
   */
  _registerEventListeners: function () {
    var onMouseMove = _.debounce(this.onMouseMove.bind(this), 100);

    this.on('mousemove', onMouseMove, this);
    this.on('click', this.onClick, this);
    this.once('draw:drawstop', this.disable, this);
  },

  /**
   * Retrieve and flatten all path layers so that they can be passed to
   * `canCollide` so we can figure out whether or not we need to run the
   * collision algorithm against it
   *
   * @return {Object} [description]
   */
  _getAllLayers: function () {
    var collections = this.Store.get('layers');
    return _.reduce(collections, function (memo, collection) {
      return memo.concat(collection);
    }, []);
  },

  _checkCollisions: function (e) {
    var options = this._options;
    var draw = this._draw;
    var canCollide = options.canCollide;

    if (canCollide && typeof canCollide === 'function') {
      var segment;
      var layers = this._getAllLayers();
      var point = latlngToPointGeoJSON(e.latlng);
      var collisionFound = false;

      if (draw && draw._poly) {
        segment = getLineSegmentGeoJSON(e.latlng, this._draw._poly._latlngs);
      }

      _.forEach(layers, function (layer) {
        if (!collisionFound && canCollide(layer)) {
          if (GeometryUtils.drawCollides(point, segment, layer.data)) {
            draw.options.drawError.message = options.strings.errors.collision;
            draw.options.drawError.timeout = 15000;

            if (draw._showErrorTooltip) {
              draw._showErrorTooltip();
            }

            // remove the last vertex if this was triggered by a click
            if (e.type === 'click') {
              draw.deleteLastVertex();
            }

            collisionFound = true;
          } else {
            if (draw && draw._hideErrorTooltip) {
              draw._hideErrorTooltip();
            }
          }
        }
      });
    }

    function latlngToPointGeoJSON (latlng) {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [latlng.lng, latlng.lat]
        }
      };
    }

    function getLineSegmentGeoJSON (currentLatLng, drawnLatLngs) {
      var lastVertex = drawnLatLngs[drawnLatLngs.length - 1];

      // when triggered by a click the event latlng and the last placed vertex
      // are the same position, so we need to set lastVertex to the one before
      if (_.isEqual(currentLatLng, lastVertex)) {
        lastVertex = drawnLatLngs[drawnLatLngs.length - 2];
      }

      return  lastVertex && {
        type: 'Feature',
        geometry: {
          type: 'LineSegment',
          coordinates: [
            [lastVertex.lng, lastVertex.lat],
            [currentLatLng.lng, currentLatLng.lat]
          ]
        }
      };
    }
  },

  //////////////////////////////////////////////////////////////////////////////
  // Handlers
  //////////////////////////////////////////////////////////////////////////////

  onMouseMove: function (e) {
    this._checkCollisions(e);
  },

  onClick: function (e) {
    this._checkCollisions(e);
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/draw/handlers/mixins/EventMixin.js